module.exports = "/_next/static/images/cca_blog-071cce237d643c8e3e151d337a54a4bb.jpg";